import React from 'react';
import PropTypes from 'prop-types';

import BEM from 'components/utils/BEM';

const FormGroup = ({
  children,
  className,
  active,
  touched,
  error,
  ...restProps
}) => (
  <div
    className={BEM('form__group')({
      error: !!(touched && error),
      focused: active,
    }).mix(className)}
    {...restProps}
  >
    {children}
  </div>
);

FormGroup.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  touched: PropTypes.bool,
  active: PropTypes.bool,
  error: PropTypes.string,
};

FormGroup.defaultProps = {
  children: null,
  className: '',
  touched: false,
  error: '',
};

export default FormGroup;
